import { BaseModel, DateField, enumField, ModelInstance, ToBackHook, ToFrontHook } from './util';
import { UserProfile } from './user-profile';
import { File } from './file';
import { City } from './city';
import { BasketballProfile } from './basketball-profile';
import { VolleyballProfile } from './volleyball-profile';
import { HockeyProfile } from './hockey-profile';
import { FootballProfile } from './football-profile';
import { HandballProfile } from './handball-profile';
import { RugbyProfile } from './rugby-profile';
import { WaterpoloProfile } from './waterpolo-profile';
import { WrestballProfile } from './wrestball-profile';

export enum UserGender {
  male = 1,
  female
}

@ModelInstance({
  mappingFields: {
    id: 'id',
    last_name: 'lastName',
    first_name: 'firstName',
    middle_name: 'middleName',
    email: 'email',
    phone: 'phone',
    birth_date: 'birthDate',
    photo: 'photo',
    profile: 'profile',
    basketball_profile: 'basketballProfile',
    volleyball_profile: 'volleyballProfile',
    hockey_profile: 'hockeyProfile',
    football_profile: 'footballProfile',
    handball_profile: 'handballProfile',
    rugby_profile: 'rugbyProfile',
    waterpolo_profile: 'waterpoloProfile',
    wrestball_profile: 'wrestballProfile',
    wizards: 'wizards',
    city: 'city',
    gender: 'gender',
    is_active: 'isActive',
    unique_code: 'uniqueCode',
    created_by_league_id: 'createdByLeagueId',
  },
  relation: {
    birthDate: DateField,
    photo: File,
    profile: UserProfile,
    basketballProfile: BasketballProfile,
    volleyballProfile: VolleyballProfile,
    hockeyProfile: HockeyProfile,
    footballProfile: FootballProfile,
    handballProfile: HandballProfile,
    rugbyProfile: RugbyProfile,
    waterpoloProfile: WaterpoloProfile,
    wrestballProfile: WrestballProfile,
    city: City,
    gender: enumField(UserGender)
  }
})
export class User extends BaseModel {
  id: number;
  lastName: string;
  firstName: string;
  middleName: string;
  email: string;
  phone: string;
  birthDate: Date;
  profile: UserProfile;
  basketballProfile: BasketballProfile;
  volleyballProfile: VolleyballProfile;
  hockeyProfile: HockeyProfile;
  footballProfile: FootballProfile;
  handballProfile: HandballProfile;
  rugbyProfile: RugbyProfile;
  waterpoloProfile: WaterpoloProfile;
  wrestballProfile: WrestballProfile;
  photo: File;
  wizards: string[];
  city: City;
  gender: UserGender;
  isActive: boolean;
  uniqueCode: string;
  createdByLeagueId: number;

  @ToFrontHook
  static toFront(data: any): any {
    return null;
  }

  @ToBackHook
  static toBack(user: User): any {
    return null;
  }

  get fullName(): string {
    return [this.lastName, this.firstName].filter(s => s).join(' ');
  }

  get shortName(): string {
    return [this.lastName, this.firstName].filter(s => s).join(' ');
  }

  get initials(): string {
    return [this.lastName, this.firstName].filter(s => s).map(s => s.substr(0, 1)).join('');
  }

  get age(): number {
    if (!this.birthDate) {
      return null;
    }
    const diff = (new Date()).getTime() - this.birthDate.getTime();
    return Math.floor(diff / (1000 * 60 * 60 * 24 * 365.25));
  }
}
